import * as React from 'react';

export function CreditCardStatementIcon({ className, ...props }: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={1.25}
            strokeLinecap="round"
            strokeLinejoin="round"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <path d="M16.5 2.5 H5.5 A1.5 1.5 0 0 0 4 4 V20 A1.5 1.5 0 0 0 5.5 21.5 H18.5 A1.5 1.5 0 0 0 20 20 V6 L16.5 2.5 Z" />
            <path d="M16.5 2.5 V6 H20" />

            <path d="M7 6.75 H16.5" />
            <path d="M7 9.5 H12.75" />

            <rect x={8.75} y={12.5} width={8.25} height={6} rx={1.5} />
            <path d="M8.75 14.6 H17" />
        </svg>
    );
}
